import "./rsvp.scss";

import React, { useState, useEffect } from "react";
import { collection, getDocs, updateDoc, doc } from "firebase/firestore";
import {
  createGuestGroup,
  fromFirestoreDoc,
  toFirestoreGuestGroup,
} from "../../models/guestGroup";
import { db } from "../../firebase";
import LoadingOverlay from "../../components/loading/LoadingOverlay";

//use firestore
//iterate creating forms for each / elements for each Name
export default function RSVP() {
  const isEmulator = window.location.hostname === "localhost";

  // const RSVP_END_DATE = new Date("March 11, 2026 23:59:59");
  const isEndDatePassed = true;

  const RSVP_LANDING_MESSAGE =
    "Please confirm your presence through the online RSVP form by March 11 2026. Enter the email address that your invitation was sent to below:";
  const RSVP_MESSAGE_1 = "We'd love to celebrate with you!";
  const RSVP_MESSAGE_2 =
    "Please let us know if you are able to attend by March 11 2026.";
  const CEREMONY_QUERY = "Will you be attending the church ceremony?";
  const RECEPTION_QUERY = "Will you be attending the reception?";
  const MESSAGE_QUERY =
    "Is there a message you would like to give Chris & Ella?";
  const EMAIL_ERROR_RESPONSE = `The email address entered is invalid or could not be found. \nPlease check and try again.`;
  const RSVP_THANK_YOU_MESSAGE =
    "Thank you for your response! We look forward to celebrating with you.";
  const RSVP_ALREADY_RESPONDED_MESSAGE =
    "Our records indicate that you have already submitted your RSVP. If you need to make changes, please contact the hosts directly.";
  const BACK_TO_MAIN_PAGE_TEXT = "Return to the main page";
  const ATTENDING = "yes, I will be attending!";
  const NOT_ATTENDING = "no, regretfully unable to attend.";

  //data
  const [data, setData] = useState([]);
  const [isGuest, setIsGuest] = useState(false); //default user is not a guest

  const [isValidEmail, setIsValidEmail] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");

  const [guestGroup, setGuestGroup] = useState(createGuestGroup());

  //form sent
  const [isFormSent, setIsFormSent] = useState(false);
  const [imagesLoaded, setImagesLoaded] = useState(false);

  // Example: custom hook to check when your images load
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setImagesLoaded(true);
    }, 1500);
    return () => clearTimeout(timeoutId);
  }, []);

  //fetch data
  // useEffect(() => {
  //   const fetchData = async () => {
  //     const snapshot = await getDocs(collection(db, "guestGroup"));
  //     const fetchedData = snapshot.docs.map(fromFirestoreDoc);
  //     setData(fetchedData);
  //   };
  //   fetchData();
  // }, []);

  // Validate email before enabling verification button
  // function handleValidation() {
  //   const emailInput = document.getElementById(
  //     "email-verification-input",
  //   ).value;
  //   const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput);
  //   setIsValidEmail(isValid);
  // }

  // // Find and load guest group by email
  // function handleEmailVerification() {
  //   const email = document
  //     .getElementById("email-verification-input")
  //     .value.trim()
  //     .toLowerCase();

  //   const matchedGroup = data.find((g) => g.email.toLowerCase() === email);

  //   if (matchedGroup) {
  //     if (matchedGroup) {
  //       setGuestGroup({
  //         ...matchedGroup,
  //         guests: matchedGroup.guests.map((g) => ({
  //           ...g,
  //           isAttendingCeremony:
  //             g.isAttendingCeremony === false ? null : g.isAttendingCeremony,
  //           isAttendingReception:
  //             g.isAttendingReception === false ? null : g.isAttendingReception,
  //         })),
  //       });
  //       setIsGuest(true);
  //     }
  //   } else {
  //     setIsGuest(false);
  //     setErrorMessage(EMAIL_ERROR_RESPONSE);
  //   }
  // }

  // Handle RSVP selection changes
  // function handleRsvpChange(index, field, radioSelection) {
  //   const updatedStatus = [...guestGroup.guests];
  //   updatedStatus[index] = {
  //     ...updatedStatus[index],
  //     [field]: radioSelection,
  //   };
  //   setGuestGroup((prev) => ({
  //     ...prev,
  //     guests: updatedStatus,
  //   }));
  // }

  // validate that all guests have selected the radio buttons before enabling submit button

  // Submit RSVP to Firestore
  // async function submitRSVP(e) {
  //   if (!canSubmitRSVP()) {
  //     alert("Please answer all questions before submitting.");
  //     return;
  //   }
  //   e.preventDefault();
  //   console.log("Attempting to submit RSVP for guestGroup:", guestGroup);

  //   // Safety check: does guestGroup exist?
  //   if (!guestGroup) {
  //     console.error("guestGroup is undefined!");
  //     alert("Something went wrong: guest data is missing.");
  //     return;
  //   }

  //   // Safety check: does guestGroup have a valid id?
  //   if (!guestGroup.id) {
  //     console.error("guestGroup.id is missing!", guestGroup);
  //     alert("Something went wrong: Guest ID is missing.");
  //     return;
  //   }

  //   // Safety check: is guests array valid?
  //   if (!Array.isArray(guestGroup.guests) || guestGroup.guests.length === 0) {
  //     console.error(
  //       "guestGroup.guests is invalid or empty!",
  //       guestGroup.guests,
  //     );
  //     alert("Something went wrong: Guest list is empty.");
  //     return;
  //   }

  //   try {
  //     const guestRef = doc(db, "guestGroup", guestGroup.id);

  //     // Log what we are about to send to Firestore
  //     const updateData = {
  //       guests: guestGroup.guests,
  //       message: guestGroup.message || "",
  //       hasResponded: true,
  //     };
  //     console.log("Updating Firestore document with:", updateData);

  //     await updateDoc(guestRef, updateData);

  //     console.log("RSVP successfully updated in Firestore.");

  //     // Update local state
  //     setGuestGroup((prev) => ({
  //       ...prev,
  //       hasResponded: true,
  //     }));
  //     setIsFormSent(true);

  //     alert("RSVP submitted successfully! Thank you.");
  //   } catch (error) {
  //     console.error("Error submitting RSVP:", error);

  //     // Provide more informative message depending on error
  //     if (error.code === "permission-denied") {
  //       alert("Cannot submit RSVP: Firestore permissions denied.");
  //     } else if (error.code === "not-found") {
  //       alert("Cannot submit RSVP: Document not found.");
  //     } else {
  //       alert("Something went wrong. Check console for details.");
  //     }
  //   }
  // }

  // function canSubmitRSVP() {
  //   return guestGroup.guests.every(
  //     (guest) =>
  //       guest.isAttendingCeremony !== null &&
  //       guest.isAttendingReception !== null,
  //   );
  // }

  return (
    <>
      <LoadingOverlay isLoading={!imagesLoaded} />
      <div className={`rsvp-container ${imagesLoaded ? "fade-in" : ""}`}>
        {!isGuest && !isFormSent && (
          <>
            <div className="rsvp-bg"></div>
            <div className="rsvp-landing-page">
              {/* {!isEndDatePassed && (
                <>
                  <h2 className="rsvp-header cormorant-400 letter-spacing-8">
                    RSVP
                  </h2>
                  <form
                    className="verification-container"
                    method="post"
                    onSubmit={(e) => {
                      e.preventDefault(); //prevent page reload
                      handleEmailVerification();
                    }}
                  >
                    <label
                      className="cormorant-light-500"
                      htmlFor="email-verification-input"
                    >
                      {RSVP_LANDING_MESSAGE}
                    </label>
                    <input
                      id="email-verification-input"
                      type="email"
                      placeholder="your@email.com"
                      onKeyUp={handleValidation}
                    />
                    <button disabled={!isValidEmail} type="submit">
                      VALIDATE EMAIL
                    </button>
                    <p className="cormorant-light-500 error-message">
                      {" "}
                      {errorMessage.split("\n").map((line, index) => (
                        <React.Fragment key={index}>
                          {line}
                          <br />
                        </React.Fragment>
                      ))}
                    </p>
                  </form>
                </>
              )} */}
              {isEndDatePassed && (
                <>
                  <div className="cormorant-italic-400 rsvp-deadline-message font-size-5">
                    The RSVP deadline has passed, and we are no longer accepting
                    responses. Please contact us if you have any questions!
                  </div>
                </>
              )}
            </div>
          </>
        )}
        {/* guest hasn't responded  */}
        {/* {!isEndDatePassed &&
          isGuest &&
          !isFormSent &&
          !guestGroup.hasResponded && (
            <div className="form-container form-fade-in">
              <div className="rsvp-messages-container">
                <div className="rsvp-messages">
                  <h2 className="rsvp-header cormorant-400 letter-spacing-8">
                    RSVP
                  </h2>
                  <p className="padding-bottom-4">{RSVP_MESSAGE_1}</p>
                  <p className="padding-bottom-8">{RSVP_MESSAGE_2}</p>
                  <div className="rsvp-picture overflow-hidden"></div>
                </div>
              </div>
              <form className="rsvp-form" onSubmit={submitRSVP} method="post">
                {guestGroup.guests.map((guest, index) => (
                  <div key={index} className="rsvp-entry">
                    <h4 className="rsvp-name cormorant-700">{guest.name}</h4>
                    <div className="rsvp-query">{CEREMONY_QUERY}</div>
                    <div className="rsvp-radio-group">
                      <div className="rsvp-radio-option">
                        <input
                          type="radio"
                          id={`yesCeremony-${index}`}
                          name={`isAttendingCeremony-${index}`}
                          value="1"
                          onChange={(e) =>
                            handleRsvpChange(index, "isAttendingCeremony", true)
                          }
                        />
                        <label htmlFor={`isAttendingCeremony-${index}`}>
                          {ATTENDING}
                        </label>
                      </div>
                      <div className="rsvp-radio-option">
                        <input
                          type="radio"
                          id={`noCeremony-${index}`}
                          name={`isAttendingCeremony-${index}`}
                          value="0"
                          onChange={(e) =>
                            handleRsvpChange(
                              index,
                              "isAttendingCeremony",
                              false,
                            )
                          }
                        />
                        <label htmlFor={`isAttendingCeremony-${index}`}>
                          {NOT_ATTENDING}
                        </label>
                      </div>
                    </div>
                    <div className="rsvp-query">{RECEPTION_QUERY}</div>
                    <div className="rsvp-radio-group">
                      <div className="rsvp-radio-option">
                        <input
                          type="radio"
                          id={`yesReception-${index}`}
                          name={`isAttendingReception-${index}`}
                          value="1"
                          onChange={(e) =>
                            handleRsvpChange(
                              index,
                              "isAttendingReception",
                              true,
                            )
                          }
                        />{" "}
                        <label htmlFor={`isAttendingReception-${index}`}>
                          {ATTENDING}
                        </label>
                      </div>
                      <div className="rsvp-radio-option">
                        <input
                          type="radio"
                          id={`noReception-${index}`}
                          name={`isAttendingReception-${index}`}
                          value="0"
                          onChange={(e) =>
                            handleRsvpChange(
                              index,
                              "isAttendingReception",
                              false,
                            )
                          }
                        />{" "}
                        <label htmlFor={`isAttendingReception-${index}`}>
                          {NOT_ATTENDING}
                        </label>
                      </div>
                    </div>
                  </div>
                ))}
                <div className="message-input-container">
                  <label htmlFor="message-input">
                    <h4 className="cormorant-400 rsvp-name text-center padding-bottom-3">
                      {MESSAGE_QUERY}
                    </h4>
                  </label>
                  <textarea
                    id="message-input"
                    name="message-input"
                    className="message-input"
                    placeholder="Your message here..."
                    maxLength="255"
                    value={guestGroup.message}
                    onChange={(e) =>
                      setGuestGroup((prev) => ({
                        ...prev,
                        message: e.target.value,
                      }))
                    }
                  ></textarea>
                </div>
                <div className="rsvp-submit padding-top-5">
                  <button type="submit" disabled={!canSubmitRSVP()}>
                    SUBMIT RSVP
                  </button>
                </div>
              </form>
            </div>
          )}

        {!isEndDatePassed &&
          isGuest &&
          isFormSent &&
          guestGroup.hasResponded && (
            <>
              <div className="rsvp-bg"></div>
              <div className="rsvp-responded">
                <p className="cormorant-light-500 padding-bottom-4">
                  {RSVP_THANK_YOU_MESSAGE}
                </p>
                <button>
                  <a className="cormorant-700 letter-spacing-2" href="/">
                    {BACK_TO_MAIN_PAGE_TEXT}
                  </a>
                </button>
              </div>
            </>
          )}

        {!isEndDatePassed &&
          isGuest &&
          !isFormSent &&
          guestGroup.hasResponded && (
            <>
              <div className="rsvp-bg"></div>
              <div className="rsvp-responded">
                <p className="cormorant-light-500 padding-bottom-4">
                  {RSVP_ALREADY_RESPONDED_MESSAGE}
                </p>
                {isEmulator && <button onClick={resetRSVP}>Reset</button>}
                <button>
                  <a className="cormorant-700 letter-spacing-2" href="/">
                    {BACK_TO_MAIN_PAGE_TEXT}{" "}
                  </a>
                </button>
              </div>
            </>
          )} */}
      </div>
    </>
  );
}
